/**
 * Tiny shared UI / string helpers for the import wizard. Pulled out so
 * the truncation cap and the em-dash placeholder live in one place — a
 * future tweak to either lands in one file instead of being scattered
 * across the four step components.
 */

import React from 'react';
import styles from '../Integrations.module.scss';

/**
 * Truncate `s` to `max` characters, appending a single-glyph ellipsis
 * (`…`, not three dots) when shorter. Returns the original string when
 * `s.length <= max`.
 */
export function truncate(s: string, max: number): string {
  return s.length > max ? `${s.slice(0, max)}…` : s;
}

/** Visual placeholder for an empty cell in the review / failure tables. */
export function EmptyCell() {
  return <span className={styles.previewMuted}>&mdash;</span>;
}

/** Render `value` when non-empty, otherwise the em-dash placeholder. */
export function valueOrDash(value: string | null | undefined): React.ReactNode {
  return value ? value : <EmptyCell />;
}
